import _regeneratorRuntime from "@babel/runtime/helpers/regeneratorRuntime";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import auth from '@lcai/console-auth';
import fetcher from '@lcai/console-fetcher-base';
export default function dataAuthLogin(_x) {
  return _dataAuthLogin.apply(this, arguments);
}
function _dataAuthLogin() {
  _dataAuthLogin = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(params) {
    var data0, info;
    return _regeneratorRuntime().wrap(function (_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.next = 1;
          return fetcher.post('/system/auth/login-platform', {
            username: params.username,
            password: params.password
          });
        case 1:
          data0 = _context.sent;
          info = {
            id: String(data0.userId),
            name: params.username,
            tenantId: String(data0.tenantId),
            token: data0.accessToken,
            timeExpired: data0.expiresTime
          };
          auth.save(info);
          window.postMessage({
            type: 'lcai.console.login'
          }, location.href);
          return _context.abrupt("return", info);
        case 2:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return _dataAuthLogin.apply(this, arguments);
}
//# sourceMappingURL=data-auth-login.js.map